import { connect } from 'react-redux'
import CadastroVeiculoModal from './modal';

export default connect()(CadastroVeiculoModal);
